<div class="rounded-md bg-gray-50 p-8">
  <h6 class="mb-8 uppercase">Podsumowanie zamówienia</h6>

  @for (item of items(); track item.id) {
    <app-public-order-checkout-item [item]="item" />

    <p-divider appPrimengDivider />
  } @empty {
    <h6>Koszyk jest pusty.</h6>
  }

  <!-- TODO Kiedyś wdrożymy obsługę kuponów -->
  @if (false) {
    <app-public-order-checkout-discount-code
      (submitEvent)="handleDiscountCodeSubmitEvent($event)" />
  }

  <div class="flex items-center gap-1">
    <div class="flex-1 font-light text-gray-500">Wartość koszyka</div>
    <div class="font-bold text-gray-600">
      <app-currency [amount]="cartTotalCosts()" />
    </div>
  </div>

  <p-divider appPrimengDivider />

  <div class="flex items-center gap-1">
    <div class="flex-1 font-light text-gray-500">Dostawa</div>
    <div class="flex flex-col items-end justify-center font-bold text-gray-600">
      <div class="inline-flex justify-end gap-1">
        <div class="flex flex-col items-end">
          <app-currency [amount]="deliveryCosts()" />
        </div>
      </div>

      @if (isNotNil(shippingMethod())) {
        <div class="flex justify-end text-sm">
          {{ shippingMethod() }}
        </div>
      }

      @if (deliveryQuantity() > 1) {
        <div class="w-3/4">
          <p-divider
            appPrimengDivider
            class="my-2 w-3/4" />

          <app-public-order-summary-additional-shipping-cost-info
            [quantity]="deliveryQuantity()"
            [unitPrice]="deliveryUnitPrice()" />
        </div>
      }
    </div>
  </div>

  @let description = shippingMethodDescription();

  @if (isNotNil(description)) {
    <div class="mt-1 flex justify-end text-xs">
      <app-summernote-html-preview [html]="description" />
    </div>
  }

  <p-divider appPrimengDivider />

  @let discountData = discount();

  @if (isNotNil(discountData)) {
    <div class="flex items-center gap-1">
      <div class="flex-1 font-light text-gray-500">
        Rabat ({{ discountData.description }})
      </div>
      <div class="flex gap-1 font-bold text-gray-600">
        <span>-</span>
        <app-currency [amount]="discountData.discount" />
      </div>
    </div>

    <p-divider appPrimengDivider />
  }

  <div class="flex items-center gap-1 font-bold">
    <div class="flex-1 text-gray-500">Łącznie do zapłaty (z VAT)</div>
    <div class="text-xl">
      <app-currency [amount]="totalCosts()" />
    </div>
  </div>

  @if (recursive().length > 0) {
    <p-divider appPrimengDivider />

    <app-public-order-summary-recursive-info [recursive]="recursive()" />
  }
</div>
